class NotificationService {
  constructor() {
    this.audio = new Audio('/notification-sound.mp3');
    this.audio.volume = 0.5; // Volume à 50%
  }

  // Jouer le son
  playSound() {
    if (this.audio) {
      this.audio.play().catch(err => console.log('Son non joué:', err));
    }
  }

  // Envoyer une notification avec son
  async sendNotification(title, message, options = {}) {
    // Vérifier permission
    if ('Notification' in window && Notification.permission === 'granted') {
      // Créer la notification
      const notification = new Notification(title, {
        body: message,
        icon: '/logo192.png',
        badge: '/logo192.png',
        tag: 'skipperlog-notification',
        requireInteraction: options.requireInteraction || false,
        ...options
      });

      // JOUER LE SON
      this.playSound();

      // Auto-fermeture après 10 secondes (sauf si requireInteraction)
      if (!options.requireInteraction) {
        setTimeout(() => notification.close(), 10000);
      }

      return notification;
    }

    return null;
  }

  // Demander permission
  async requestPermission() {
    if ('Notification' in window) {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    }
    return false;
  }
}

export const notificationService = new NotificationService();